var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import { getTypographyStyles } from '../../../common/styles/typography';
import { getHeadingStylesBySize } from './getHeadingStylesBySize';
import { getHeadingStylesByVariant } from './getHeadingStylesByVariant';
// Utils
import styled from 'styled-components';
export var Heading = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.4;\n"], ["\n  ", "\n  ", "\n  ", "\n\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.4;\n"])), function (_a) {
    var theme = _a.theme, textOverflow = _a.textOverflow;
    return getTypographyStyles(textOverflow, theme);
}, function (_a) {
    var size = _a.size;
    return getHeadingStylesBySize(size);
}, function (_a) {
    var theme = _a.theme;
    return getHeadingStylesByVariant(theme);
});
var templateObject_1;
//# sourceMappingURL=Heading.js.map